export const T = {
  en_GB: {
    compliance: "Compliance",
    breadcrumb: "Batch Lookup",
    title: "PEP/Sanction Batch Lookup",
    description: "Run PEP and Sanction screening on multiple clients at once using a client view.",
  },
  nb_NO: {
    compliance: "Compliance",
    breadcrumb: "Batchoppslag",
    title: "PEP/sanksjonssøk for flere kunder",
    description: "Kjør PEP- og sanksjonssøk på flere kunder samtidig ved hjelp av en kundevisning.",
  },
} as const;
